import React, { useState } from 'react';
import api from '../api/axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const RecuperarContrasena = () => {
  const [telefono, setTelefono] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [esCorrecto, setEsCorrecto] = useState(false);

  const handleSubmit = async () => {
    if (!telefono || !email) {
      toast.warning('Introduce teléfono y correo electrónico');
      return;
    }
    setLoading(true);
    try {
      await api.post('/auth/recuperar-contrasena', { telefono, email });
      toast.success('Correo de recuperación enviado correctamente');
      setEsCorrecto(true);
    } catch (error) {
      console.error(error);
      if (error.response?.status === 404) {
        toast.error('Teléfono y correo no coinciden con ningún usuario');
        setEsCorrecto(false);
      } else {
        toast.error('Error al enviar el correo de recuperación');
        setEsCorrecto(false);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className='site-width'>
      <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar={false} />
      <div className="form-login">
        <h2>Recupera tu contraseña</h2>
        <p>Ingresa tu número de teléfono y correo electrónico para restaurar tu contraseña. Al rellenar los siguientes campos, restaurarás tu contraseña creando una nueva, segura y temporal.</p>
        <div className="campos-recuperar">

          <div className="label-form">
            <label htmlFor="telefono">Número de teléfono <span className="obligatorio">*</span></label>
            <PhoneInput
              country="es"
              value={telefono}
              onChange={value => setTelefono(value)}
              placeholder="Teléfono"
              inputProps={{ name: 'telefono' }}
            />
          </div>

          <div className="label-form">
            <label htmlFor="email">Correo electrónico <span className='obligatorio'>*</span></label>
            <input
              name="email"
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          {esCorrecto && <div className='contrasena-recuperada'>
            <p>Contraseña restaurada correctamente y enviada a tu correo electrónico</p>
            </div>}

          <button className="boton-iniciar-sesion" onClick={handleSubmit} disabled={loading}>
            {loading ? 'Enviando...' : 'Restaurar contraseña'}
          </button>

        </div>
      </div>
    </main>
  );
};

export default RecuperarContrasena;
